// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"ruler"},"children":[{"tag":"path","attrs":{"id":"fill1","fill":"props.fillColor1","d":"M7.5 3L3 21H12L16.5 3H7.5Z"}},{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M21 21H12M12 21H3L7.5 3H16.5L12 21ZM7 7.5H10.875M5.5 12H9.75M4.5 16.5H8.625","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const RulerIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'ruler',
    ref,
    icon: element,
  },
));

RulerIcon.displayName = 'RulerIcon';

export default RulerIcon;
